import { render, staticRenderFns } from "./AlikeScore.vue?vue&type=template&id=ed897e7a"
import script from "./AlikeScore.vue?vue&type=script&lang=js"
export * from "./AlikeScore.vue?vue&type=script&lang=js"
import style0 from "./AlikeScore.vue?vue&type=style&index=0&id=ed897e7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports